import React, { ReactNode } from 'react'
import { makeStyles } from 'tss-react/mui'
import { IconButton, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'

export interface NonModalSheetProps {
  open: boolean
  onClose: () => void
  title?: string
  containerClass?: string
  contentClass?: string
  children?: ReactNode
}

export const useStyles = makeStyles()((theme) => {
  return {
    sheet: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: theme.palette.background.paper,
      boxShadow: `0 -3px 6px 0 ${theme.palette.grey[500]}`,
      transition: 'transform 0.3s ease',
      zIndex: 99,
      padding: theme.spacing(0, 4),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 8),
      },
    },
    noTranslate: {
      transform: 'translateY(0)',
    },
    translateFully: {
      transform: 'translateY(100%)',
    },
    closeIcon: {
      position: 'absolute',
      right: 0,
      top: theme.spacing(3),
      color: theme.palette.text.primary,
    },
    content: {
      overflowY: 'auto',
      maxHeight: '50vh',
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    title: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
    },
  }
})

const NonModalSheet: React.FC<NonModalSheetProps> = ({
  open,
  onClose,
  title,
  containerClass,
  contentClass,
  children,
}) => {
  const { classes, cx } = useStyles()

  return (
    <>
      <div
        className={cx(
          classes.sheet,
          containerClass,
          open ? classes.noTranslate : classes.translateFully
        )}
        data-testid="sheet"
      >
        <div className={cx(classes.content, contentClass)}>
          {title ? (
            <div className={classes.titleContainer}>
              <Typography className={classes.title}>{title}</Typography>
              <IconButton size="small" aria-label="close" onClick={onClose}>
                <Close fontSize="small" />
              </IconButton>
            </div>
          ) : (
            <IconButton
              size="small"
              aria-label="close"
              className={classes.closeIcon}
              onClick={onClose}
            >
              <Close fontSize="small" />
            </IconButton>
          )}
          {children}
        </div>
      </div>
    </>
  )
}

export default NonModalSheet
